module.exports = __webpack_public_path__ + "img/case-yys.69ac8213.png";